import { useState } from 'react';
import { Info, Plus, Sparkle, X } from '@phosphor-icons/react';
import { ImmoButton, InnenKarte, KartenTitel, TextFeld, ToastPill, useToastPill } from '../../../../../components/immobilien/ui';
import { supabase } from '../../../../../lib/supabase/client';
import { useObjektSeite } from '../ObjektSeitenKontext';

/**
 * Panel „KI-Aliase“: Andere Schreibweisen des Objekts für die E-Mail-Zuordnung.
 * Gleiche Logik wie die bisherige Aliase-Karte (objekt_aliase, quelle 'manuell', keine Dubletten).
 */
export function AliasePanel() {
  const { daten, neuLaden } = useObjektSeite();
  const [toast, zeige] = useToastPill();
  const [neu, setNeu] = useState('');
  const [laeuft, setLaeuft] = useState(false);
  const objektId = daten.objekt.id;

  const hinzufuegen = async () => {
    const wert = neu.trim();
    if (!wert) return;
    if (daten.aliase.some(a => a.alias.toLowerCase() === wert.toLowerCase())) { zeige('Diesen Alias gibt es schon', true); return; }
    setLaeuft(true);
    const { error } = await supabase.from('objekt_aliase').insert({ objekt_id: objektId, alias: wert, quelle: 'manuell' });
    setLaeuft(false);
    if (error) { zeige(`Alias konnte nicht gespeichert werden: ${error.message}`, true); return; }
    setNeu('');
    zeige(`„${wert}“ hinzugefügt`);
    neuLaden('aliase');
  };

  const entferne = async (id: string, alias: string) => {
    const { error } = await supabase.from('objekt_aliase').delete().eq('id', id);
    if (error) { zeige(`Löschen fehlgeschlagen: ${error.message}`, true); return; }
    zeige(`„${alias}“ entfernt`);
    neuLaden('aliase');
  };

  return (
    <>
      {toast && <ToastPill text={toast.text} fehler={toast.fehler} />}
      <InnenKarte>
        <KartenTitel icon={Sparkle} rechts={`${daten.aliase.length} ${daten.aliase.length === 1 ? 'Alias' : 'Aliase'}`}>Schreibweisen für die E-Mail-Zuordnung</KartenTitel>
        <div className="flex flex-wrap" style={{ gap: 8 }}>
          {daten.aliase.length === 0 && <span style={{ fontSize: 13, color: 'var(--ink3)' }}>Noch keine Aliase.</span>}
          {daten.aliase.map(a => (
            <span key={a.id} className="flex items-center" style={{ height: 32, padding: '0 6px 0 12px', borderRadius: 16, gap: 6, fontSize: 13, fontWeight: 600, background: a.quelle === 'gelernt' ? 'var(--info-soft)' : 'var(--acc-soft)', color: a.quelle === 'gelernt' ? 'var(--info)' : 'var(--acc)' }}
              title={a.quelle === 'gelernt' ? 'Von der KI gelernt' : 'Manuell angelegt'}>
              {a.alias}
              <button type="button" aria-label={`Alias ${a.alias} entfernen`} onClick={() => { void entferne(a.id, a.alias); }} className="flex items-center justify-center cursor-pointer"
                style={{ width: 22, height: 22, borderRadius: '50%', border: 'none', background: 'transparent', color: 'inherit' }}>
                <X weight="bold" size={11} />
              </button>
            </span>
          ))}
        </div>
        <form className="flex items-end flex-wrap" style={{ gap: 10 }} onSubmit={e => { e.preventDefault(); void hinzufuegen(); }}>
          <div style={{ flex: '1 1 260px' }}>
            <TextFeld label="Neuer Alias" wert={neu} onChange={setNeu} placeholder="z. B. Alte Str. 17 oder WEG Wallau" kompakt />
          </div>
          <ImmoButton type="submit" art="akzent" groesse={44} pille={false} icon={Plus} disabled={!neu.trim() || laeuft}>Hinzufügen</ImmoButton>
        </form>
      </InnenKarte>
      <InnenKarte style={{ flexDirection: 'row', alignItems: 'flex-start', gap: 12 }}>
        <Info weight="fill" size={20} color="var(--info)" style={{ flexShrink: 0, marginTop: 2 }} />
        <span style={{ fontSize: 12, color: 'var(--ink2)', lineHeight: 1.45 }}>
          Die E-Mail-Analyse erkennt das Objekt auch an diesen Schreibweisen. Blau markierte Aliase hat die KI aus bestätigten Zuordnungen gelernt.
        </span>
      </InnenKarte>
    </>
  );
}
